import React, {useEffect, useState} from "react";
import {Input} from "@material-tailwind/react";
import DatePicker, {DateObject} from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persianFa from "react-date-object/locales/persian_fa";
import {BsX} from "react-icons/bs";
import "../../style/datePicker.css";

const INPUT_FORMAT = "YYYY-MM-DD";
const DISPLAY_FORMAT = "YYYY/MM/DD";

function createDate(value) {
  if (!value) {
    return null;
  }

  return new DateObject({
    date: value,
    format: INPUT_FORMAT,
    calendar: persian,
    locale: persianFa,
  });
}

function createRange(fromDate, toDate) {
  return [createDate(fromDate), createDate(toDate)].filter(Boolean);
}

export function PersianDateRangeInput({
                                        fromDate,
                                        toDate,
                                        setFromDate,
                                        setToDate,
                                        placeholder = "بازه تاریخ",
                                        className = "",
                                        inputClassName = "",
                                      }) {
  const [range, setRange] = useState(() => createRange(fromDate, toDate));

  useEffect(() => {
    setRange(createRange(fromDate, toDate));
  }, [fromDate, toDate]);

  const clearRange = () => {
    setRange([]);
    setFromDate("");
    setToDate("");
  };

  const handleChange = (dates) => {
    const nextRange = Array.isArray(dates) ? dates : [];
    setRange(nextRange);

    if (nextRange.length === 0) {
      clearRange();
      return;
    }

    if (nextRange.length === 2) {
      setFromDate(nextRange[0].format(INPUT_FORMAT));
      setToDate(nextRange[1].format(INPUT_FORMAT));
    }
  };

  const handleClose = () => {
    if (range.length === 1) {
      setRange(createRange(fromDate, toDate));
    }
  };

  return (
    <div
      className={`relative w-full ${className}`}
      style={{direction: "rtl"}}
    >
      <DatePicker
        range
        rangeHover
        value={range}
        onChange={handleChange}
        onClose={handleClose}
        calendar={persian}
        locale={persianFa}
        format={DISPLAY_FORMAT}
        dateSeparator=" تا "
        calendarPosition="bottom-right"
        editable={false}
        className="rmdp-calendar"
        containerClassName="w-full"
        render={
          <Input
            variant="outlined"
            placeholder={placeholder}
            className={`w-full !pl-10 ${inputClassName}`}
          />
        }
      />

      {(fromDate || toDate) && (
        <button
          type="button"
          aria-label="پاک کردن بازه تاریخ"
          onClick={clearRange}
          className="absolute left-3 top-1/2 z-10 -translate-y-1/2 rounded-full p-1 text-blue-gray-400 transition-colors hover:bg-blue-gray-50 hover:text-blue-gray-700"
        >
          <BsX className="h-4 w-4"/>
        </button>
      )}
    </div>
  );
}
